module.exports = __webpack_public_path__ + "WLicon.png?b2b38f8509dab15d20f852245ad28f0d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/WLicon.png
// module id = 51
// module chunks = 0